module.exports = __webpack_public_path__ + "static/yelan-banner-16a2759d2a30b506bbc7d4686eefbf53.png";